(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("luna-markdown-viewer"));
	else if(typeof define === 'function' && define.amd)
		define(["luna-markdown-viewer"], factory);
	else if(typeof exports === 'object')
		exports["LunaMarkdownEditor"] = factory(require("luna-markdown-viewer"));
	else
		root["LunaMarkdownEditor"] = factory(root["LunaMarkdownViewer"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__93__) {
return 